module.exports = __webpack_public_path__ + "static/media/nova-logo.8dafe1a2.svg";